<div class="note-item block">
    <div class="note-tags">
        <div class="tag" *ngIf="note.customer">{{ note.customer.companyDisplayName || note.customer.companyName }}</div>
        <div class="tag" *ngIf="note.markedUser">{{ note.markedUser?.displayName || note.markedUser?.username }}</div>
    </div>
    <div class="edit-note-button" (click)="editMode = true" *ngIf="!editMode && changeableByCurrentUser" title="Notiz ändern"></div>
    <div class="save-note-button" (click)="save()" *ngIf="editMode && changeableByCurrentUser" title="Änderungen speichern"></div>
    <div class="note-item-content" [innerHTML]="note.text | nl2br" [contentEditable]="editMode" (input)="textChanged($event)"></div>

    <div class="note-item-info">
        <app-avatar-placeholder size="1.25rem" [name]="note.user?.displayName || note.user?.username"></app-avatar-placeholder>
        <div class="ml-2">
            Erstellt von {{ note.user?.displayName || note.user?.username }}
        </div>
    </div>
    <div class="note-item-date">
        <div class="inline-block mr-2 text-red-600 cursor-pointer hover:underline" (click)="delete()" *ngIf="changeableByCurrentUser">Löschen</div>
        {{ note.created | date: 'dd. MMM \'yy' }}
    </div>

</div>
